<script setup>
  import {
    computed,
    onMounted,
  } from 'vue'

  import { useWatchWindowSize } from '@composables/useWatchWindowSize.js'

  const props = defineProps({
    maxLinksCount: {
      default: 10,
      type: Number,
    },
    modelValue: Number, // 現在のページ番号
    per: Number, // １ページあたりの件数
    total: Number, // 全体の件数
  })

  const emits = defineEmits(['move', 'update:modelValue'])

  const enabledPrev = computed(() => props.modelValue > 1)
  const enabledNext = computed(() => props.modelValue < maxPage.value)
  const maxLinks = computed(() => Math.min(props.maxLinksCount, windowWidth.value < 576 ? 7 : 99))
  const maxPage = computed(() => parseInt((props.total - 1) / props.per) + 1)
  const pages = computed(() => [...Array(Math.min(maxPage.value - pagesStart.value + 1, maxLinks.value))].map((_, i) => i + pagesStart.value))
  const pagesStart = computed(() => maxPage.value <= maxLinks.value ? 1 : Math.min(maxPage.value - maxLinks.value + 1, Math.max(1, props.modelValue - parseInt(maxLinks.value / 2))))

  const {
    windowWidth,
    watchWindowWidth
  } = useWatchWindowSize()

  onMounted(() => {
    const url = new URL(window.location.href)
    const page = parseInt(url.searchParams.get('page'))
    if (page && !isNaN(page)) {
      setPage(page)
    }
    watchWindowWidth()
  })

  const move = (direction) => setPage(props.modelValue + direction)

  const page = (value) => setPage(value)

  const setPage = (value) => {
    emits('update:modelValue', value)
    emits('move', value)

    const url = new URL(window.location.href)
    url.searchParams.delete('page')
    url.searchParams.append('page', value)
    window.history.pushState({}, '', url)
  }
</script>

<template>
  <ul v-if="modelValue && per && total && maxPage > 1" class="c-pagination js-fadeUp">
    <li>
      <template v-if="enabledPrev">
        <a class="page-numbers prev active" @click.prevent="move(-1)"><i class="fa-solid fa-angle-left"></i></a>
      </template>
      <template v-else>
        <span class="page-numbers prev"><i class="fa-solid fa-angle-left"></i></span>
      </template>
    </li>
    <li v-for="p in pages" :key="`page-${page}`">
      <span v-if="p == modelValue" class="current page-numbers">{{ p }}</span>
      <a v-else class="page-numbers" @click="page(p)">{{ p }}</a>
    </li>
    <li>
      <template v-if="enabledNext">
        <a class="page-numbers next active" @click.prevent="move(1)"><i class="fa-solid fa-angle-right"></i></a>
      </template>
      <template v-else>
        <span class="page-numbers next"><i class="fa-solid fa-angle-right"></i></span>
      </template>
    </li>
  </ul>
</template>
